export const GET_NOTIFICATION_START='GET_NOTIFICATION_START'
export const GET_NOTIFICATION_SUCCESS='GET_NOTIFICATION_SUCCESS'
export const GET_NOTIFICATION_FAIL='GET_NOTIFICATION_FAIL'


export const SEND_NOTIFICATION_START = "SEND_NOTIFICATION_START"
export const SEND_NOTIFICATION_SUCCESS = "SEND_NOTIFICATION_SUCCESS"
export const SEND_NOTIFICATION_FAILS = "SEND_NOTIFICATION_FAILS"


export const RESET_NOTIFICATION_ALERT = "RESET_NOTIFICATION_ALERT";


export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION"
export const DELETE_NOTIFICATION_SUCCESS ="DELETE_NOTIFICATION_SUCCESS"
export const DELETE_NOTIFICATION_FAILED = "DELETE_NOTIFICATION_FAILED"


export const SEND_EMP_MAIL = "SEND_EMP_MAIL"
export const SEND_EMP_MAIL_SUCCESS = "SEND_EMP_MAIL_SUCCESS"
export const SEND_EMP_MAIL_FAILED = "SEND_EMP_MAIL_FAILED"
